import {ContentListProps} from 'presentation/components/StyledCard/types';
import {TELEMEDICINE_INFO} from 'presentation/pages/private/booking/constants';
import {formatText} from 'presentation/utils';

import {TelemedicineEnum} from 'presentation/modules/booking/shared/constants/telemedicineEnum';
import {BuildContentListParams} from './types';

export function buildContentHistoryList({
	colors,
	appointment,
}: BuildContentListParams): ContentListProps[] {
	const {clinic, specialty, provider} = appointment;

	const isTelemedicine = clinic.telemedicine === TelemedicineEnum.IS_TELEMEDICINE;
	return [
		{
			iconName: 'medical-services-filled',
			iconColor: colors.light.primary['190Percent'],
			primaryText: formatText(specialty?.description),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			alignItems: 'center',
		},
		{
			iconName: 'doctor-filled',
			iconColor: colors.light.primary['190Percent'],
			primaryText: formatText(provider?.name),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			alignItems: 'center',
		},
		{
			iconName: 'location-on-filled',
			iconColor: colors.light.primary['190Percent'],
			primaryText: isTelemedicine
				? formatText(TELEMEDICINE_INFO.name)
				: formatText(clinic?.name),
			primaryTextFontSize: '0.875rem',
			primaryTextLineHeight: '1.25rem',
			alignItems: 'center',
			customTypographyGap: '0px',
		},
	].filter(cardInfo => cardInfo.primaryText) as ContentListProps[];
}
